import { currencyFormatter } from '../utils/currencyFormatter.js';

/**
 * Handle the "Buy Now" button functionality and the order process, including PayPal button rendering.
 * If the total amount is greater than zero, the PayPal buttons are shown for payment processing.
 * If the total amount is zero (due to coupons or other discounts), the order is sent directly to Eventive.
 *
 * @param {Order} order - The current order details, including items, prices, and any applied discounts.
 */
export function uiUpdateByNowAndOrderButton(order) {
  const buyNowButton = document.getElementById('by_now_button');
  const totalAmountElement = document.getElementById('by__now__button__amount__text');

  let totalAmount = order?.total || 0;
  let orderQuantity = order?.total_quantity || 0;

  totalAmountElement.textContent = currencyFormatter(totalAmount / 100);

  // The button is activated if either the amount > 0 or the amount is 0 and an order quantity > 0 exists.
  if (totalAmount > 0 || (totalAmount <= 0 && orderQuantity > 0)) {
    buyNowButton.classList.remove('disabled');
  } else {
    buyNowButton.classList.add('disabled');
  }

}

